module.exports = __webpack_public_path__ + "img/atlas-logo.961e2ee4.png";